module.exports = __webpack_public_path__ + "img/usp_silencer.73d66a5e.svg";